import { useState } from 'react'
import { Props_SnippetVideo } from './Video.props'
import { Legacy_CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

export const convertIframeUrl = (url: string): string => {
   let newUrl = url;

    const youtubeDomains = [
    'youtube.com',
    'youtu.be',
    'm.youtube.com',
]

    for (const youtubeDomain of youtubeDomains) {
        if (newUrl.includes(youtubeDomain)) {
            // Handle YouTube Shorts
            if (newUrl.includes("/shorts/")) {
                const videoIdMatch = newUrl.match(/\/shorts\/([a-zA-Z0-9_-]+)/);
                if (videoIdMatch) {
                    newUrl = `https://www.youtube-nocookie.com/embed/${videoIdMatch[1]}`;
                }
            }
            // Handle youtu.be short URLs
            else if (newUrl.includes("youtu.be/")) {
                newUrl = newUrl.replace("youtu.be/", "www.youtube-nocookie.com/embed/");
            }
            // Handle watch?v= URLs
            else if (newUrl.includes("watch?v=")) {
                newUrl = newUrl.replace("watch?v=", "embed/");
                newUrl = newUrl.replace(youtubeDomain, "youtube-nocookie.com");
            }
            // Handle other youtube.com URLs (already embedded or direct)
            else {
                newUrl = newUrl.replace(youtubeDomain, "youtube-nocookie.com");
            }
            
            let separator = newUrl.includes("?") ? "&" : "?";
            
            if (!newUrl.includes("enablejsapi=")) {
                newUrl = `${newUrl}${separator}enablejsapi=1`;
                separator = "&"; // After first param, always use &
            }
            
            if (!newUrl.includes("origin=")) {
                newUrl = `${newUrl}${separator}origin=${encodeURIComponent(window.location.origin)}`;
            }

            break;
        }
    }
    
    // Handle Vimeo URLs
    if (newUrl.includes("vimeo.com")) {
        const match = newUrl.match(/vimeo\.com\/(\d+)/);
        if (match) {
            newUrl = `https://player.vimeo.com/video/${match[1]}`
        }
    }
    
    // Add autoplay for all URLs if not already present (after other params)
    if (!newUrl.includes("autoplay=")) {
        const separator = newUrl.includes("?") ? "&" : "?";
        newUrl = `${newUrl}${separator}autoplay=1`;
    }
    
    return newUrl
}

const Video = (props: Props_SnippetVideo) => {
    const { heading, content, link, video } = props

    const [playing, setPlaying] = useState(false)
    const convertedUrl = convertIframeUrl(video?.url?.value ?? '')
    const classBase: string = `snippet-video`
    const classSnippetTheme: string = props.snippet?.theme?.value ? `${classBase}--theme-${props.snippet.theme.value}` : ''
    const classHeadingVisibility: string = heading.visibility.value === 'false' ? `${classBase}__heading--hidden` : ''
    const classVideoPosition: string = `${classBase}--video-position-${video?.position?.value}`
    const classVideoFullscreen: string = video?.fullWidth?.value === 'true' ? `${classBase}--video-fullwidth` : ''
    const classVideoPlaying: string = playing ? `${classBase}--video-playing` : ''

    return (
        <section className={`snippet-video ${classSnippetTheme} ${classVideoPosition} ${classVideoFullscreen} ${classVideoPlaying}`}>
            <div className="snippet-video__container">
                <div className="snippet-video__container-video">
                    <button
                        className="snippet-video__play-button play-button"
                        aria-label="{{js.snippet.video.button.play.aria-label}}"
                        onClick={() => setPlaying(true)}
                    ></button>
                    { video?.image?.value && (
                        <img
                            loading="lazy"
                            className="snippet-video__thumbnail"
                            width="1920"
                            height="1080"
                            src={video?.image?.value}
                            alt=""
                        />
                    )}
                    {video?.url?.value && (
                        <iframe
                            width="1920"
                            height="1080"
                            src={playing ? convertedUrl : undefined}
                            title="YouTube video player"
                            loading="lazy"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            className="snippet-video__video"
                            allowFullScreen={true}
                        ></iframe>
                    )}
                </div>
                <div className="snippet-video__container-content">
                    <h2 className={`snippet-video__heading ${classHeadingVisibility}`}>{heading?.content?.value}</h2>
                    <div className="snippet-video__content">
                        { content?.content?.value && Legacy_CompileMarkdown(content.content.value) }
                    </div>
                    {link?.linkUrl?.value && link?.linkText?.value && (
                        <a href={link?.linkUrl?.value}
                            className="snippet-video__cta attrax-button"
                            aria-label={link?.linkText?.value}
                            target={link?.linkTarget?.value === 'true' ? '_blank' : '_self'}
                            rel={link?.linkTarget?.value === 'true' ? 'noopener noreferrer' : undefined}
                        >
                            {link?.linkText?.value}
                        </a>
                    )}
                </div>
            </div>
        </section>
    )
}

export default Video
